import _map from 'lodash/map'

import Paragraph from 'components/Paragraph'
import CardService from 'components/Card/CardService'
import Link from 'components/Link'

import Styled from './styled'

export default function SectionInstallation({ data }) {
  const title = data?.title
  const subTitle = data?.subTitle
  const installationCards = data?.installation
  const newInstallationCards = installationCards?.slice(0, 10)
  const installationCardCount = newInstallationCards?.length || 4
   

  return (
    <Styled serviceItems={installationCardCount}>
      <div className="header">
        <Paragraph className="title font-semibold">{title}</Paragraph>
        <Paragraph className="sub-title">{subTitle}</Paragraph>
      </div>
      <div className="service-content">
        {_map(newInstallationCards, (item, index) => {
          const name = item?.name
          const image = item?.image?.url
          const link = item?.url || 'javascript: void(0);'
          
          return (
            <div className='service-content-item' key={index}>
              <Link href={link}>
                <CardService title={name} image={image} />
              </Link>
            </div>
          )
        })}
      </div>
    </Styled>
  )
}
